import React, { Component } from "react";
import { idEmpresa, PDF, aparienciaFirma } from "../../constans/constants";
import {
  updateTipoDocumento, setTipoDocumento,
  getDatosFormulario, getDocumento, updateXsdFile, validarPlantilla
}
  from "../tiposDocumento/TipoDocumentoService";
import AparienciaFirma from "./AparienciaFirma";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import BreadCrumComponent from '../../components/componentes/BreadCrumComponent';
import img_success from '../../assets/images/ilustraciones/img-success.svg';
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { validateForm } from "../../constans/validationUtils";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';

class NuevoTipoDocumento extends Component {
  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      id: "",
      idEmpresa: idEmpresa(),
      nombreDocumento: "",
      descripcion: "",
      formatoArchivo: "",
      formatoMetadato: "",
      origen: "",
      carpetaPorDefecto: "",
      carpetaPorDefectoActive: false,
      archivoXls: null,
      errorMensajeArchivoXls: null,
      archivoXlsActive: false,
      validacionArchivoEnProgreso: false,
      isFirmaEmpresa: false,
      isFirmaColaborador: false,
      acciones: "",
      employeeComment: false,
      notificarFirmaColaborador: false,
      tipoEnvio: "",
      formatosImportacion: [],
      accionesEmpleado: [],
      origenLote: [],
      enterpSignatureFormat: "",
      employeeSignatureFormat: "",
      tipoEnvioMtess: [
        {
          key: 1,
          value: "LOTE_MANUAL",
          descripcion: "Por lote cerrado, previa confirmacion manual",
        },
      ],
      errors: {
        nombreDocumento: null,
        descripcion: null,
        formatoArchivo: null,
        metaFormato: null,
        origen: null,
        carpetaPorDefecto: null,
        acciones: null,
        tipoEnvio: null,
        archivoXls: null
      },
      firmas: [],
      mensaje: "",
      severity: "",
      openPantallaCarga: false,
      cronJobActive: false,
      isAparienciaFirma: true,
      estadoAparienciaFirma: "",
      remindDaysAfterPublish: 0,
      remindFrecuencyDays: 0,
      remindFrecuencyHours: 0,
      remindFrecuencyMinutes: 0,
      validated: false,
      editar: false,
      finCargaFormulario: false,
      continuarAparienciaFirma: false,
      finCreacionDocumento: false,
      errores: [],
      tipoAccion,
      titulo: null,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",

    };
  }

  reglasValidacionCampos = {
    nombreDocumento: [
      { required: true, message: 'Ingrese un nombre para el documento' },
    ],
    descripcion: [
      { required: true, message: 'Ingrese una descripcion para el documento' },
    ],
    formatoArchivo: [
      { required: true, message: 'Elija un formato de importacion' },
    ],
    metaFormato: [
      { required: true, message: 'Debe agregar un formato de nombre para los documentos' },
    ],
    origen: [
      { required: true, message: 'Elija un punto de origen para cargar lotes' },
    ],
    carpetaPorDefecto: [
      {
        customValidator: (value, formData) => {
          if (!this.state.carpetaPorDefectoActive)
            return true
          else
            return value.length > 0
        }, message: 'Debe ingresar una ruta de archivos valida'
      },
    ],
    archivoXls: [
      {
        customValidator: (value, formData) => {
          if (!this.state.archivoXlsActive)
            return true
          else
            return !!this.state.archivoXls
        }, message: 'Debe cargar una plantilla'
      },
    ],
    acciones: [
      { required: true, message: 'Elija que acciones ejecutara el colaborador al recibir el documento' },
    ],
    tipoEnvio: [
      { required: true, message: 'Elija como se enviaran los documentos al MTESS' },
    ]
  }

  async componentDidMount() {
    
    configurarLimpiezaAutomatica()

    getDatosFormulario().then((res) => {
      this.setState({
        formatosImportacion: res.formatoImp,
        accionesEmpleado: res.tipFirmaEmpleado,
        origenLote: res.origenLote,

      });
    })

    if (this.state.tipoAccion === "edit") {

      const { datos } = this.props.location.state;

      getDocumento(datos.id).then((res) => {
        if (!res.error) {
          this.setState({
            id: datos.id,
            nombreDocumento: res.datos.nombre,
            descripcion: res.datos.descripcion,
            formatoArchivo: res.datos.formato.id,
            metaFormato: res.datos.metaFromato,
            origen: res.datos.origenLote.id,
            acciones: res.datos.firmaEmpleado.id,
            isFirmaEmpresa: res.datos.firmaEmpresa,
            isFirmaColaborador: res.datos.firmaEmpleado.nombre.toLowerCase().includes("firma"),
            employeeComment: res.datos.employeeComment,
            employeeSignatureFormat: res.datos.formatoFirmaEmpleado,
            enterpSignatureFormat: res.datos.formatoFirmaEmpresa,
            tipoEnvio: res.datos.tipoEnvioMtess,
            cronJobActive: res.datos.cronJobActive,
            remindDaysAfterPublish: res.datos.remindDaysAfterPublish,
            remindFrecuencyDays: res.datos.remindFrecuencyDays,
            remindFrecuencyHours: res.datos.remindFrecuencyHours,
            remindFrecuencyMinutes: res.datos.remindFrecuencyMinutes,
            archivoXlsActive: res.datos.formato.extension == 'XML',
            carpetaPorDefectoActive: res.datos.carpeta.length > 0,
            carpetaPorDefecto: res.datos.carpeta,
            notificarFirmaColaborador: res.datos.notificarFirma,
            editar: true,
            titulo: "Datos del tipo documento " + res.datos.nombre
          });
        } else {

          this.setState({
            mostrarMensajeFlash: true,
            mensajeFlash: res.mensaje,
            mensajeFlashSeverity: 'error'
          });
        }

      });
    }
  }

  handleDialog = () => {
    const {
      isFirmaColaborador,
      isFirmaEmpresa,
      employeeSignatureFormat,
      enterpSignatureFormat,
    } = this.state;

    // Verificar si las firmas activas tienen un formato válido
    const firmaColaboradorValida = !isFirmaColaborador || (employeeSignatureFormat && employeeSignatureFormat.trim() !== "");
    const firmaEmpresaValida = !isFirmaEmpresa || (enterpSignatureFormat && enterpSignatureFormat.trim() !== "");

    const isAparienciaFirma =
      firmaColaboradorValida &&
      firmaEmpresaValida &&
      (isFirmaColaborador || isFirmaEmpresa);

    this.setState({ isAparienciaFirma }, () => {
      this.handleSubmit();
    });
  };

  handleChecked = (event) => {
    let name = event.target.name;
    let val = event.target.checked;
    if (!val) {
      this.setState({
        [name]: val,
        remindDaysAfterPublish: 0,
        remindFrecuencyDays: 0,
        remindFrecuencyHours: 0,
        remindFrecuencyMinutes: 0
      });
    } else {
      this.setState({
        [name]: val,
      });
    }
  }

  handleUploadArchivoXml = (event) => {
    limpiarErrorCampo('archivoXls');
        this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        archivoXls: null
      },
      archivoXls: event.target.files[0]
    }));
  }

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    switch (name) {
      case "formatoArchivo":
        if (val == "1") this.setState({ archivoXlsActive: true });
        else this.setState({ archivoXlsActive: false });
        break;
      case "origen":
        if (val == "1") {
          this.setState({
            carpetaPorDefectoActive: true,
          });
        } else {
          this.setState({
            carpetaPorDefectoActive: false,
          });
        }
        break;
      case "acciones": {
        let isFirmaColaborador = false;
        this.state.accionesEmpleado.forEach((e) => {
          if (e.id == val)
            isFirmaColaborador = e.nombre.includes("Firma")
        })
        this.setState({ isFirmaColaborador: isFirmaColaborador })
        break;
      }
      case "isFirmaEmpresa":
        val = e.target.value === 'true';
        break;

    }
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };


  signEmpresa = (sign) => {
    this.setState({ enterpSignatureFormat: sign })
  }
  signEmpleado = (sign) => {
    this.setState({ employeeSignatureFormat: sign })
  }


  handleClose = (mensaje, severity) => {
    this.props.handleClose(mensaje, severity);
  };

  guardarTipoDocumento = (data) => {
    this.setState({ openPantallaCarga: true });
    if (this.state.tipoAccion == "edit") {
      data.id = this.state.id;
      updateTipoDocumento(data).then(res => {
        if (!res.error) {
          if (this.state.archivoXls != null) {
            let id = res.datos.id;
            let XSLFile = new FormData();
            XSLFile.append("file", this.state.archivoXls);
            updateXsdFile(XSLFile, id).then(response => {
              this.props.history.push({
                pathname: '/configuracion/tipo-documento/editar/' + (response.error ? 'error' : 'exito'),
                state: { data: res.datos }
              })
            })
          } else {
            this.props.history.push({
              pathname: '/configuracion/tipo-documento/editar/' + (res.error ? 'error' : 'exito'),
              state: { data: res.datos }
            })
          }
        } else {
          try {
            const errores = JSON.parse(res.mensaje)
            this.setState({
              openPantallaCarga: false,
              errors: errores
            })
          } catch (e) {
            this.setState({
              mostrarMensajeFlash: true,
              mensaje: res.mensaje,
              severity: "danger",
              openPantallaCarga: false
            })
            this.handleClose(true)
          }
        }
      })

    } else {
      setTipoDocumento(data).then(res => {
        if (!res.error) {
          if (this.state.archivoXls != null) {
            let id = res.datos.id;
            let XSLFile = new FormData();
            XSLFile.append("file", this.state.archivoXls);
            updateXsdFile(XSLFile, id).then(response => {
              this.props.history.push({
                pathname: '/configuracion/tipo-documento/crear/' + (response.error ? 'error' : 'exito'),
                state: { data: res.datos }
              })

            })
          } else {
            this.props.history.push({
              pathname: '/configuracion/tipo-documento/crear/exito',
              state: { data: res.datos }
            })
          }

        } else {
          try {
            const errores = JSON.parse(res.mensaje)

            this.props.history.push({
              pathname: '/configuracion/tipo-documento/crear/error',
              state: { errors: errores }
            })

          } catch (e) {
            this.setState({
              mostrarMensajeFlash: true,
              mensaje: res.mensaje,
              severity: "danger",
              openPantallaCarga: false
            })
            this.handleClose(true)
          }
        }
      })
    }
  }

  handleCargaDatos = () => {
    if (this.state.formatoArchivo == PDF && this.state.enterpSignatureFormat == "" && this.state.employeeSignatureFormat == "" && aparienciaFirma)
      this.setState({ isAparienciaFirma: false });
    this.setState({ finCargaFormulario: true })
  }

  handleSubmit = (e = null) => {
    if (e != null)
      e.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({});
      let data = {
        id: "",
        name: this.state.nombreDocumento,
        description: this.state.descripcion,
        defaultFolder: this.state.carpetaPorDefecto,
        metaFormat: this.state.metaFormato,
        enterpSignature: this.state.isFirmaEmpresa,
        employeeSignatureId: this.state.acciones,
        formatId: this.state.formatoArchivo,
        bacthSourceId: this.state.origen,
        empresaId: idEmpresa(),
        enterpSignatureFormat: this.state.enterpSignatureFormat,
        employeeSignatureFormat: this.state.employeeSignatureFormat,
        seTransmite: 0,
        employeeComment: this.state.employeeComment,
        notificarFirma: this.state.notificarFirmaColaborador,
        cronJobActive: this.state.cronJobActive,
        remindDaysAfterPublish: this.state.remindDaysAfterPublish,
        remindFrecuencyDays: this.state.remindFrecuencyDays,
        remindFrecuencyHours: this.state.remindFrecuencyHours,
        remindFrecuencyMinutes: this.state.remindFrecuencyMinutes,
        keystoreId: "",
        tipoEnvioMtess: this.state.tipoEnvio,
      };

      if (data.formatId == PDF && data.enterpSignatureFormat == "" && data.employeeSignatureFormat == "" && aparienciaFirma) {
        this.setState({ isAparienciaFirma: false });
        this.guardarTipoDocumento(data)
      } else {
        this.guardarTipoDocumento(data)
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };


  handleClickContinuar = () => {
    if (this.state.formatoArchivo == PDF) {
      this.setState({ continuarAparienciaFirma: true, finCargaFormulario: false })
    } else {
      this.props.history.push('/configuracion/tipo-documento');
    }
  }

  renderFormulario = () => {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/configuracion/tipo-documento'}
                breadcrumbs={
                  [
                    { label: 'Configuraciones', path: '/configuracion/tipo-documento' },
                    { label: 'Tipos de documentos', path: '/configuracion/tipo-documento' },
                    { label: this.props.match.params.tipoAccion !== 'edit' ? 'Registrar nuevo documento' : 'Editar tipo de documento', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.titulo ?? "Registrar nuevo Tipo de Documento"}</h1>
                  <p className="page-description"> Complete el siguiente formulario con los datos solicitados </p>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <div className="component-content card">
                <form onSubmit={this.state.formatoArchivo == PDF ? this.handleCargaDatos : this.handleSubmit} className="form container-sm">

                  <h3 className="form-subtitle"> Datos Básicos </h3>
                  <div className="form-group__inline">
                    <div className="form-group">
                      <input type="text" name="nombreDocumento" id="nombreDocumento" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.nombreDocumento} />
                      <label htmlFor="nombreDocumento" className="form-label"> Nombre de Tipo de documento </label>
                    </div>

                    <div className="form-group">
                      <input type="text" name="descripcion" id="descripcion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.descripcion} />
                      <label htmlFor="descripcion" className="form-label"> Descripción </label>
                    </div>
                  </div>

                  <hr />

                  <h3 className="form-subtitle"> Opciones de importación </h3>

                  <div className="form-group__inline">

                    <div className="form-group">
                      <select className="form-select" name="formatoArchivo" id="formatoArchivo" placeholder="" onChange={this.handleInput} value={this.state.formatoArchivo}>
                        <option key="" value="">Seleccione un formato</option>
                        {this.state.formatosImportacion.map((elemento) => (
                          <option key={elemento.codigo} value={elemento.id}>
                            {elemento.extension}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="formatoArchivo" className="form-label"> Formato de importación </label>
                    </div>

                    {this.state.archivoXlsActive &&
                      <div className="form-group">
                        <input className="form-input inputFile" name="archivoXls" type="file" accept=".jrxml" id="archivoXls"onChange={this.handleUploadArchivoXml}/>
                        <label htmlFor="archivoXls" className="form-label"> Subir plantilla (.jrxml) </label>
                      </div>
                    }

                    <div className="form-group">
                      <input type="text" name="metaFormato" id="metaFormato" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.metaFormato} />
                      <label htmlFor="metaFormato" className="form-label"> Formato de nombre c/ Metadato </label>
                    </div>

                    <div className="form-group">
                      <select className="form-select" name="origen" id="origen" onChange={this.handleInput} value={this.state.origen}>
                        <option key="" value=""> </option>
                        {this.state.origenLote.map((elemento) => (
                          <option key={elemento.codigo} value={elemento.id}>
                            {elemento.nombre}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="origen" className="form-label"> Origen del Lote </label>
                    </div>

                    {this.state.carpetaPorDefectoActive &&
                      <div className="form-group">
                        <input type="text" name="carpetaPorDefecto" id="carpetaPorDefecto" placeholder="" onChange={this.handleInput} className="form-input" value={this.state.carpetaPorDefecto} />
                        <label htmlFor="carpetaPorDefecto" className="form-label"> Carpeta por defecto </label>
                      </div>
                    }
                  </div>

                  <hr />

                  <h3 className="form-subtitle"> Opciones de firma </h3>
                  <div className="form-group__inline">
                    <div className="form-group">
                      <select className="form-select" name="isFirmaEmpresa" id="isFirmaEmpresa" placeholder="" onChange={this.handleInput} value={this.state.isFirmaEmpresa}>
                        <option key={true} value={true}>Si</option>
                        <option key={true} value={false}>No</option>
                      </select>
                      <label htmlFor="isFirmaEmpresa" className="form-label"> Firma de empresa </label>
                    </div>

                    <div className="form-group">
                      <select className="form-select" name="acciones" id="acciones" placeholder="" onChange={this.handleInput} value={this.state.acciones}>
                        <option key="" value="" selected></option>
                        {this.state.accionesEmpleado.map((elemento) => (
                          <option key={elemento.codigo} value={elemento.id}>
                            {elemento.nombre}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="acciones" className="form-label"> Acciones Colaborador </label>
                    </div>

                    <div className="form-group">
                      <input type="checkbox" className="form-check" name="employeeComment" id="employeeComment" placeholder="" onChange={this.handleChecked} checked={this.state.employeeComment} />
                      <label htmlFor="employeeComment" className="check-label"> Permitir comentario en firma </label>
                    </div>
                    <div className="form-group">
                      <input type="checkbox" className="form-check" name="notificarFirmaColaborador" id="notificarFirmaColaborador" placeholder="" onChange={this.handleChecked} checked={this.state.notificarFirmaColaborador} />
                      <label htmlFor="notificarFirmaColaborador" className="check-label"> Notificar Firma del Colaborador </label>
                    </div>
                    <div className="form-group">
                      <select className="form-select" name="tipoEnvio" id="tipoEnvio" placeholder="" onChange={this.handleInput} value={this.state.tipoEnvio}>
                        <option key="" value="" selected></option>
                        {this.state.tipoEnvioMtess.map((elemento) => (
                          <option key={elemento.key} value={elemento.value}>
                            {elemento.descripcion}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="tipoEnvio" className="form-label"> Tipo de envío MTESS </label>
                    </div>

                  </div>

                  <hr />

                  <h3 className="form-subtitle"> Recordatorio </h3>

                  <div className="form-group">

                    <input type="checkbox" className="form-check" name="cronJobActive" id="cronJobActive" onChange={this.handleChecked} value={this.state.cronJobActive} />
                    <label htmlFor="cronJobActive" className="check-label"> Configurar recordatorio para firmantes </label>

                    {this.state.cronJobActive &&

                      <div className="form-group__inline x4">
                        <div className="form-group">
                          <input type="number" min={1} name="remindDaysAfterPublish" id="remindDaysAfterPublish" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.remindDaysAfterPublish} />
                          <label htmlFor="remindDaysAfterPublish" className="form-label"> Días a partir de publicación </label>
                        </div>

                        <div className="form-group">
                          <input type="number" min={0} name="remindFrecuencyDays" id="remindFrecuencyDays" className="form-input" placeholder="" value={this.state.remindFrecuencyDays} onChange={this.handleInput} />
                          <label htmlFor="remindFrecuencyDays" className="form-label"> Días </label>
                        </div>

                        <div className="form-group">
                          <input type="number" min={0} name="remindFrecuencyHours" id="remindFrecuencyHours" className="form-input" placeholder="" value={this.state.remindFrecuencyHours} onChange={this.handleInput} />
                          <label htmlFor="remindFrecuencyHours" className="form-label"> Horas </label>
                        </div>

                        <div className="form-group">
                          <input type="number" min={0} name="remindFrecuencyMinutes" id="remindFrecuencyMinutes" className="form-input" placeholder="" value={this.state.remindFrecuencyMinutes} onChange={this.handleInput} />
                          <label htmlFor="remindFrecuencyMinutes" className="form-label"> Minutos </label>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="form-actions">
                    <button onClick={() => this.props.history.push('/configuracion/tipo-documento')} className="btn-medium btn-link"> Cancelar </button>
                    <button type="submit" className="btn-medium btn-primary"> Guardar </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <MensajeFlash
            visible={this.state.mostrarMensajeFlash}
            mensaje={this.state.mensajeFlash}
            severity={this.state.mensajeFlashSeverity} />
        </div>
      </div>

    );
  }

  renderPantallaFinFormulario = () => {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl='/configuracion/tipo-documento'
                breadcrumbs={
                  [
                    { label: 'Tipos de documentos', path: '/configuracion/tipo-documento' },
                    { label: 'Registrar nuevo documento', path: '' },
                    { label: 'Resultado creacion', path: '' }
                  ]
                }
              />
            </div>
          </header>
          <div className="wrapperContent">
            <div className="component-advice">
              <div className="page-container">

                <div className="container-flex container-md">

                  <div className="col">
                    <h1 className="section__subtitle-sm">
                      {this.state.formatoArchivo != PDF ? "¡Nuevo Documento creado con éxito! " : "Datos del documento guardados"}
                    </h1>
                    <div className="card">
                      <h3 className="card-title"> Aquí tienes un resumen </h3>
                      <div className="card-info">
                        <span className="label"> Nombre de tipo de documento </span>
                        <span className="txt"> {this.state.nombreDocumento} </span>
                      </div>
                      <div className="card-info">
                        <span className="label"> Descripción </span>
                        <span className="txt"> {this.state.descripcion} </span>
                      </div>
                    </div>
                    <div className="actions">
                      <button onClick={this.handleClickContinuar} className="btn-medium btn-primary">
                        {this.state.formatoArchivo == PDF ? "Continuar Apariencia Firma" : "Finalizar"}
                      </button>
                    </div>
                  </div>

                  <div className="col">
                    <div className="illustration">
                      <img src={img_success} className="img-fluid" alt="operacion exitosa" />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }

  renderPantallaAparienciaFirma = () => {
    return (
      <AparienciaFirma
        isFirmaEmpresa={this.state.isFirmaEmpresa}
        isFirmaColaborador={this.state.isFirmaColaborador}
        handleClose={this.handleDialog}
        firmaEmpresa={this.signEmpresa}
        firmaEmpleado={this.signEmpleado}
        aparienciaEmpresa={this.state.enterpSignatureFormat}
        aparienciaEmpleado={this.state.employeeSignatureFormat}
        disabledInput={this.state.disabledInput}
        editar={this.state.editar}
      />
    );
  }

  render() {
    if (this.state.finCargaFormulario) {
      return this.renderPantallaFinFormulario()
    } else if (this.state.continuarAparienciaFirma) {
      return this.renderPantallaAparienciaFirma()
    } else {
      return this.renderFormulario()
    }
  }
}



export default NuevoTipoDocumento;
